let isAnnouncementBarInitialized = false;

function announcebar() {
  if (isAnnouncementBarInitialized) return;
  isAnnouncementBarInitialized = true;

  var defaults = {
    sections: "li",
    duration: 3000,
    loop: true,
    currentClass: "current",
    direction: "up"
  };

  function scrollText(container, options) {
    var opts = Object.assign({}, defaults, options || {});
    var sections = container.querySelectorAll(opts.sections);
    if (!sections.length) return;
    var arrElements = Array.from(sections);
    var ulElement = container.querySelector("ul");
    if (!ulElement) return;
    ulElement.classList.add("ulzone");
    var content = ulElement;
    var contentHeight = content.offsetHeight;
    var contentChildHeight = content.children[0].offsetHeight;
    var temp = contentChildHeight;
    var duration = opts.duration;
    var currentClass = opts.currentClass;
    var iIndex = 0;
    var intervalID;

    function up() {
      content.style.transition = "margin-top 1s";
      content.style.marginTop = `-${contentChildHeight}px`;
      arrElements.forEach(el => el.classList.remove(currentClass));
      iIndex += 1;
      if (arrElements[iIndex]) {
        arrElements[iIndex].classList.add(currentClass);
      }
      setTimeout(() => {
        if (contentHeight === contentChildHeight) {
          content.style.marginTop = `-${contentChildHeight}px`;
          setTimeout(over, 1000);
        } else {
          contentChildHeight += temp;
        }
      }, 1000);
    }

    function over() {
      content.style.transition = "none";
      content.style.marginTop = "0";
      contentChildHeight = temp;
      iIndex = 0;
      arrElements.forEach(el => el.classList.remove(currentClass));
      arrElements[0].classList.add(currentClass);
    }

    function initLayout() {
      var clone = content.cloneNode(true);
      content.parentNode.appendChild(clone);
      handleStyle();
      startScroll();
    }

    function handleStyle() {
      arrElements[0].classList.add(currentClass);
    }

    function startScroll() {
      if (intervalID) {
        clearInterval(intervalID);
      }
      intervalID = setInterval(up, duration);
    }

    function handleVisibilityChange() {
      if (document.hidden) {
        clearInterval(intervalID);
      } else {
        startScroll();
      }
    }

    function setupVisibilityChangeHandling() {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      document.addEventListener("visibilitychange", handleVisibilityChange);
    }

    setupVisibilityChangeHandling();
    initLayout();
  }

  document.querySelectorAll(".announce-inr, .product-usps").forEach(container => {
    scrollText(container, { duration: 3000, loop: true });
  });
}

announcebar();
// function announcebar(options){
//   var defaults = {
//     // container: '.announce-inr',
//     container: options.container,
//     sections: 'li',
//     // duration: 5000,
//     duration: options.duration,
//     loop: true,
//     currentClass: 'current',
//     direction: 'up'
//   };
//   function scrollText(opts, container){
//     if (!container) return;
//     var sections = container.querySelectorAll(opts.sections);
//     if (sections.length <= 1) return;
//     var arrElements = Array.from(sections);
//     var ul = container.querySelector('ul');
//     ul.classList.add('ulzone');
//     var content = container.querySelector('.ulzone');
//     var contentHeight = content.offsetHeight;
//     var contentChildHeight = content.children[0].scrollHeight;
//     var temp = contentChildHeight;
//     var currentClass = opts.currentClass;
//     var iIndex = 0;
//     var intervalID;
//     var firstChildClone = content.children[0].cloneNode(true);
//     content.appendChild(firstChildClone);
//     initLayout();
//     handleStyle();

//     function up(){
//       content.style.transition = 'margin-top 1s';
//       content.style.marginTop = '-' + contentChildHeight + 'px';
//       arrElements.forEach(function (el) {
//         el.classList.remove(currentClass);
//       });
//       iIndex += 1;
//       if(iIndex >= arrElements.length){
//         iIndex = 0;
//       }
//       arrElements[iIndex].classList.add(currentClass);

//       if(contentChildHeight >= contentHeight){
//         setTimeout(function(){
//           content.style.transition = 'none';
//           content.style.marginTop = '0';
//           contentChildHeight = temp;
//         }, 1000);
//       }else{
//         contentChildHeight += temp;
//       }
//     }
    
//     function initLayout(){
//       var clone = content.cloneNode(true);
//       content.parentNode.appendChild(clone);
//     }
//     function handleStyle(){
//       arrElements[iIndex].classList.add(currentClass);
//     }
//     function scroll(){
//       if(intervalID){
//         clearInterval(intervalID);
//       }
//       intervalID = setInterval(up, opts.duration);
//     }
//     function handleVisibilityChange(){
//       if(document.hidden){
//         clearInterval(intervalID);
//       }else{
//         scroll();
//       }
//     }
//     if(typeof document.hidden !== "undefined"){
//       document.addEventListener("visibilitychange", handleVisibilityChange, false);
//     }
//     scroll();
//   }
//   var mergedOptions = Object.assign({}, defaults, options || {});
//   var containers = document.querySelectorAll(mergedOptions.container);
//   containers.forEach(function (container) {
//     scrollText(mergedOptions, container);
//   });
// }
// document.addEventListener('DOMContentLoaded', function(){
//   announcebar({
//     container: '.announce-inr',
//     duration: 3000
//   });
//   announcebar({
//     container: '.product-usps',
//     duration: 3000
//   });
// });
// if(document.querySelector('.close-announce')) document.querySelector('.close-announce').addEventListener('click',function(e){
//   e.preventDefault();
//   document.querySelector('.section-announcement-bar').classList.add('hide-announce');
// });